import { ParkingFeeForMemberResponse } from '../models/register-parking';

function readBool(raw: Record<string, unknown>, ...keys: string[]): boolean {
  for (const key of keys) {
    const value = raw[key];
    if (value !== undefined && value !== null) {
      return Boolean(value);
    }
  }
  return false;
}

export function normalizeParkingFeeForMember(
  row: ParkingFeeForMemberResponse | Record<string, unknown>,
): ParkingFeeForMemberResponse {
  const raw = row as Record<string, unknown>;
  return {
    id: Number(raw['id'] ?? raw['Id'] ?? 0),
    feeName: String(raw['feeName'] ?? raw['FeeName'] ?? ''),
    feeId: Number(raw['feeId'] ?? raw['FeeId'] ?? 0),
    amount: Number(raw['amount'] ?? raw['Amount'] ?? 0),
    vat: readBool(raw, 'vat', 'Vat'),
    vatIncluded: readBool(raw, 'vatIncluded', 'VatIncluded'),
  };
}

export function normalizeParkingFeeForMemberList(
  rows: Array<ParkingFeeForMemberResponse | Record<string, unknown>> | null | undefined,
): ParkingFeeForMemberResponse[] {
  return (rows ?? []).map((row) => normalizeParkingFeeForMember(row));
}
